import CalendarApp from './CalendarApp';
import './Calendar.css';

function Calendar() {
  return <CalendarApp />;
}

export default Calendar;
